module.exports = __webpack_public_path__ + "img/sec2_22.30f4fe9f.jpg";